<template>
<div class="modal" v-show="visible" :style="{backgroundColor:isNeedBg?'rgba(0, 0, 0, .4)':'rgba(0, 0, 0, 0)'}"
    @click.self="clickBack"
    >
    <div v-show="visible"
         :class="dialogClassObj"
         :style="{width: theWidth}"
         @click="() => {}"
         >
      <div class="modal-content">
        <slot name="modal-header">
          <div class="modal-header">
            <button v-if="isNeedCloseBtn" type="button" class="close" @click="close"><span>&times;</span></button>
            <p class="modal-title">{{title}}</p>
          </div>
        </slot>
        <div class="modal-body cc-scroll" :style="{height: height + 'px'}">
          <slot name="modal-body">
          </slot>
        </div>
        <slot name="modal-footer">
          <div class="modal-footer">
            <cc-button type="confirm" @click="callback">确定</cc-button>
            <cc-button type="gray" @click="close">取消</cc-button>
          </div>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
import Button from './../Cc-Button';
export default {
  name: 'Modal'
  ,props: {
    title: String,
    show: {
      require: true,
      type: Boolean
    },
    width: String,
    height: String,
    callback: {
      type: Function,
      default () {}
    },
    backdrop: Boolean,
    //width:600px; 默认
    small: Boolean,//width:400px;
    large: Boolean//width:900px
    ,isNeedCloseBtn: {
      type: Boolean
      ,default: true
    }
    ,isNeedBg: {
      type: Boolean
      ,default: true
    }
  }
  ,data(){
    return {
     visible: this.show
     ,theWidth: this.width
    }
  }
  ,created(){
  }
  ,mounted () {
    var me = this
    window.addEventListener('keyup', (ev) => {
      if (ev.keyCode === 27) {
        me.visible = false
      }
    });
    document.body.appendChild(this.$el)

    if (this.show) {
      this.visible = true

        if(document.body.hasAttribute("modal-num")) {
          document.body.setAttribute("modal-num", Number(document.body.getAttribute("modal-num")) + 1 )
        }else {
          document.body.setAttribute("modal-num", 1)
        }

        document.body.style.overflowY = 'hidden'
        // document.body.style.paddingRight = Com.scrollbarWidth + "px"
    }

    if(this.width) {
      this.changeWidth();
      window.addEventListener('resize',this.changeWidth)
    }
  }
  ,methods:{
    open () {
      this.visible = true
    },
    close () {
      this.visible = false
    },
    clickBack () {
      if (this.backdrop) {
        this.close()
      }
    },
    changeWidth () {
      if(window.innerWidth<=900) {
        if(this.width.slice(0,-2) >= 800) {
          this.theWidth = this.width.slice(0,-2) * 7/8  + 'px'
        }
      }else {
        this.theWidth = this.width
      }
    }
  }
  ,components:{
      'ccButton':Button
  }
  ,computed:{
    dialogClassObj () {//设置modal宽度
      let { large, small } = this
      let dialogClass = {}
      dialogClass['modal-dialog'] = true
      dialogClass['modal-lg'] = large
      dialogClass['modal-sm'] = small

      return dialogClass
    }
  }
  ,watch:{
    show (newVal,oldVal) {
      if(newVal != oldVal){
        this.visible = newVal;
      }
      if(newVal) {
        if(document.body.hasAttribute("modal-num")) {
          document.body.setAttribute("modal-num", Number(document.body.getAttribute("modal-num")) + 1 )
        }else {
          document.body.setAttribute("modal-num", 1)
        }
        document.body.style.overflowY = 'hidden'
        // document.body.style.paddingRight = Com.scrollbarWidth + "px"
      }else {
        if(document.body.hasAttribute("modal-num")) {
          document.body.setAttribute("modal-num", Number(document.body.getAttribute("modal-num")) - 1 )
        }
        if(!document.body.hasAttribute("modal-num") || Number(document.body.getAttribute("modal-num")) == 0) {
          document.body.style.overflowY = 'scroll'
          document.body.style.paddingRight = '0'
        }
      }
    },
    visible (newVal,oldVal) {
      if(newVal != oldVal){
        let event = newVal ? 'open' : 'close'
        this.$emit(event)
      }
    }
  }
}
</script>

<style scoped>

.modal-open {
  overflow: hidden
}

.modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  /*z-index: 99999;*/
  -webkit-overflow-scrolling: touch;
  background-color: rgba(0, 0, 0, .4);
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .1);
  outline: 0
}

.modal-dialog {
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  min-width: 400px;
  overflow-y: auto;
  box-shadow: 0 5px 15px rgba(0, 0, 0, .6);
}

@media screen and (max-width: 900px){
  .modal-dialog {
    width: 700px;
  }
}

.modal-content {
  background-color: #f8fafc;
  background-clip: padding-box;
  outline: 0;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .05);
}

.modal-header {
  padding: 10px 15px;
  border-bottom: 1px solid #cdcdcd;
}

.modal-header .close {
  margin-top: -2px
}

.modal-header .close {
  float: right;
  font-size: 21px;
  font-weight: 700;
  line-height: 1.5;
  text-shadow: 0 1px 0 #f8fafc;
  background-color: #f8fafc;
  border: none;
  color: #b2b3b4;
}

.modal-header .close:focus,
.modal-header .close:hover,
.modal-header .close:active {
  color: #979797;
  text-decoration: none;
  cursor: pointer;
  border: none;
}

.modal-title {
  margin: 0;
  line-height: 1.4;
  font-size: 20px;
  color:#59738c;
}

.modal-body {
  position: relative;
  padding: 15px;
  word-wrap: break-word;
  max-height: 650px;
  overflow: auto;
}
@media screen and (max-height: 750px){
  .modal-body {
    max-height: 500px;
  }
}

.modal-footer {
  padding: 9px 10px;
  margin:0 5px;
  font-size: 0;
  text-align: center;
  border-top: 1px solid #cdcdcd;
}
.modal-footer button{
  margin:0 10px;
}

@media (min-width:720px) {
  .modal-dialog {
    width: 600px;
  }
  .modal-content {
    box-shadow: 0 5px 15px rgba(0, 0, 0, .5);
  }
  .modal-sm {
    width: 400px;
  }
}

@media (min-width:960px) {
  .modal-lg {
    width: 900px;
  }
}
@media (max-width:800px) {
  .modal-lg {
    width: 750px;
  }
}
.modal-footer:after,
.modal-footer:before,
.modal-header:after,
.modal-header:before{
  content: " ";
  display: table;
}
.modal-footer:after,
.modal-header:after{
  clear: both;
}

.modal-confirm .modal-body{
  min-height:120px;
}
.modal-tip .modal-body{
  padding: 30px 20px;
}
.modal-confirm .modal-footer,.modal-tip .modal-footer{
  padding-bottom: 30px;
  padding-top: 0;
  border-top: none;
}
.modal-tip .modal-footer,.modal-tip .confirm-content{
  text-align:center;
}
</style>

<style>
.confirmTip{
  line-height: 30px;
  height: 30px;
  font-size: 13px;
  padding-left: 12px;
}
</style>



// WEBPACK FOOTER //
// components/Cc-Modal/Modal.vue